import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import passportImg from '../../assets/img/passportLogo.svg'
import focusable from '../../components/Focusable/Focusable'
import { truncate } from '../../../../shared/helpers.js'
import { secondsToHms } from '../../../../shared/helpers.js'
import ProgressBar from '../ProgressBar'
import tts from '../../lib/TTS'
import {
  getTitleAndSubtitle,
  secondsToTTS,
  platformTransitionStyle,
} from '../../../../shared/helpers.js'
import classNames from 'classnames'

class GridItem extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = 'gridItem'
    this.url = ''

    if (this.props.content.item_type === 'show') {
      this.url = `/show-details/${this.props.content.slug}`
    } else if (this.props.content.item_type === 'video') {
      const url = encodeURIComponent(this.props.content.url)
      this.url = `/video-details/${url}`
    } else if (this.props.content.item_type === 'skylab-collection') {
      const url = encodeURIComponent(this.props.content.url)
      this.url = `/collections/${url}`
    } else if (this.props.content.item_type === 'season') {
      this.url = `/seasons/${this.props.content.slug}`
    }

    const metaData = this.findMetaData()
    this.state = {
      showName: metaData.showName,
      title: metaData.title,
      episode: metaData.episode,
      image: metaData.image,
      hasImage: metaData.hasImage,
      duration: metaData.duration,
      seasonNum: metaData.seasonNum,
      episodeNum: metaData.episodeNum,
      imageError: false,
    }

    this.gridLinkRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.hasFocus && this.props.hasFocus) {
      this.readTitles()
    }
  }

  readTitles() {
    const { content, view, collectionType } = this.props
    const { seasonNum } = this.state
    const { showTitle, episodeTitle } = getTitleAndSubtitle(content)
    let resource_type

    if (view !== 'show') {
      resource_type = content?.parent?.resource_type
    }

    const { duration } = content || null

    if ('undefined' === typeof collectionType) {
      if (content?.parent && content?.parent?.resource_type === 'special') {
        tts.addTextToRead([
          episodeTitle,
          resource_type,
          secondsToTTS(`${duration}`),
        ])
      } else {
        if (view === 'show') {
          tts.addTextToRead([showTitle])
        } else {
          tts.addTextToRead([showTitle, episodeTitle])
        }
      }
    } else if ('single' === collectionType) {
      if (content?.parent && content?.parent?.resource_type === 'special') {
        tts.addTextToRead([
          episodeTitle,
          resource_type,
          secondsToTTS(`${duration}`),
        ])
      } else {
        const seasonInfo = `season ${seasonNum}`
        tts.addTextToRead([
          episodeTitle,
          seasonInfo,
          `${resource_type} ${this.state.episodeNum}`,
          secondsToTTS(`${duration}`),
        ])
      }
    } else if ('all' === this.props.collectionType) {
      tts.addTextToRead([episodeTitle])
    }
  }

  onKeyEvent(key) {
    let handled = false

    if ('ENTER' === key) {
      this.gridLinkRef.current?.click()
      handled = true
    }

    return handled
  }

  findMetaData() {
    // attempt to find required metadata in the various places it may be located.
    const { content, view, collectionType } = this.props
    let metaData = {}
    let title = ''
    let specialTitle = ''
    let previewTitle = ''
    let episode = ''
    let duration = ''
    let seasonNum = 0
    let episodeNum = 0
    let showName = ''

    switch (view) {
      case 'video':
        if (content.title) {
          episode = truncate.apply(content.title, [35, true])
        }
        if (content.parent && content.parent.season) {
          title = truncate.apply(content.parent.season.show.title, [35, true])
        }
        if (content.parent && content.parent.title) {
          specialTitle = truncate.apply(content.parent.title, [35, true])
        }
        if (content.parent && content.parent.show) {
          previewTitle = truncate.apply(content.parent.show.title, [35, true])
        }

        if ('single' === collectionType) {
          if (content.title) {
            episode = truncate.apply(content.title, [35, true])
          }
          if (content.duration) {
            duration = secondsToHms(content.duration)
          }
          if (content.parent && content.parent.ordinal) {
            episodeNum = content.parent.ordinal
          }
          if (
            content.parent &&
            content.parent.season &&
            content.parent.season.ordinal
          ) {
            seasonNum = content.parent.season.ordinal
          }
        }

        showName = content.title
        duration = content.duration ? secondsToHms(content.duration) : ''
        break
      case 'skylab-collection':
        if ('all' === collectionType) {
          if (content.title) {
            episode = truncate.apply(content.title, [25, true])
          }
        }
        showName = content.title
        break
      case 'show':
        showName = content.title
        break

      default:
        break
    }

    // check for item_type and insure data is valid before render return
    let image = ''
    let hasImage = true

    if (content.images && view === 'show') {
      image = content.images['show-poster2x3']
        ? `${content.images['show-poster2x3']}?resize=260x390&format=webp`
        : ''
    } else if (content.images) {
      image = content.images['asset-mezzanine-16x9']
        ? `${content.images['asset-mezzanine-16x9']}?resize=422x240&format=webp`
        : (image = content.images['asset-kids-mezzanine1-16x9']
            ? `${content.images['asset-kids-mezzanine1-16x9']}?resize=422x240&format=webp`
            : '')
    }

    if (image === null) {
      hasImage = false
    }

    metaData.showName = showName
    metaData.title = title
      ? title
      : specialTitle
      ? specialTitle
      : previewTitle
      ? previewTitle
      : ''
    metaData.episode = episode
    metaData.image = image
    metaData.hasImage = hasImage
    metaData.duration = duration
    metaData.seasonNum = seasonNum
    metaData.episodeNum = episodeNum
    return metaData
  }

  imgError(image) {
    image.persist()
    // TODO: re-visit if we want to track missing images
    // Sentry.captureException('ImageError', {
    //   extra: { image: this.state.image },
    // })
    this.setState({ imageError: true, image: null })
  }

  render() {
    //set values to pass through cleanse
    const { hasFocus, content, view } = this.props
    const { image, showName, title, duration, episode, episodeNum, seasonNum } =
      this.state

    if (!content) return ''

    let is_mvod = content.flags
      ? content.flags.is_mvod
        ? content.flags.is_mvod
        : false
      : false

    let hasImage = true
    if (image === null) {
      hasImage = false
    }

    return (
      <Link
        className={`${view}-item`}
        style={{ position: 'relative', display: 'inline-block' }}
        to={this.url}
        ref={this.gridLinkRef}
      >
        {content && (
          <div
            className={`item-wrapper ${
              view === 'video' || view === 'skylab-collection'
                ? 'video-or-skylab'
                : ''
            }`}
          >
            <div className={classNames('show-image', { focused: hasFocus })}>
              {hasImage && (
                <>
                  <img
                    className={`thumb-image ${
                      view === 'video' || view === 'skylab-collection'
                        ? 'video-or-skylab'
                        : ''
                    }`}
                    src={image}
                    onError={(e) => this.imgError(e)}
                    alt={`${showName} grid poster`}
                  />

                  {is_mvod ? (
                    <div className="passport-triangle">
                      <img
                        className="passport-logo"
                        src={passportImg}
                        alt={'passport logo'}
                      />
                    </div>
                  ) : null}
                  {content.seconds_watched > 0 && (
                    <ProgressBar
                      current={content.seconds_watched}
                      total={content.duration}
                    />
                  )}
                </>
              )}
              {!hasImage && (
                <div
                  className={`placeholder-image ${
                    view === 'video' || view === 'skylab-collection'
                      ? 'video-or-skylab'
                      : view === 'show'
                      ? 'show'
                      : ''
                  }`}
                >
                  <div className="title-container">
                    <span className="title">{!hasImage ? showName : ''}</span>
                  </div>
                </div>
              )}
            </div>

            {
              //Not a collection use default captions
              'undefined' === typeof this.props.collectionType && (
                <div className={classNames('captions', { focused: hasFocus })}>
                  <h3 className={'title'}>{title}</h3>
                  <h3 className={'episode'}>
                    {content.parent &&
                    content.parent.resource_type === 'special'
                      ? `Special | ${duration}`
                      : episode}
                  </h3>
                </div>
              )
            }
            {'single' === this.props.collectionType && (
              <div
                className={`single-collection-captions ${
                  hasFocus ? 'focused' : ''
                }`}
              >
                <h3 className={'episode'}>{episode}</h3>
                <h3 className={`duration`}>
                  {content.parent.resource_type === 'special'
                    ? `Special | ${duration}`
                    : `S${seasonNum} Ep${episodeNum} | ${duration}`}
                </h3>
              </div>
            )}
            {'all' === this.props.collectionType && (
              <div
                className={`see-all-collection-captions ${
                  hasFocus ? 'focused' : ''
                }`}
                style={{
                  transition: platformTransitionStyle('transform 0.5s'),
                }}
              >
                <h3 className={'episode'}>
                  {truncate.apply(episode, [20, true])}
                </h3>
              </div>
            )}
          </div>
        )}
      </Link>
    )
  }
}

GridItem.propTypes = {
  collectionType: PropTypes.string,
  content: PropTypes.shape({
    duration: PropTypes.number,
    flags: PropTypes.shape({
      is_mvod: PropTypes.bool,
    }),
    images: PropTypes.object,
    item_type: PropTypes.string,
    parent: PropTypes.shape({
      ordinal: PropTypes.number,
      resource_type: PropTypes.string,
      season: PropTypes.shape({
        ordinal: PropTypes.number,
        show: PropTypes.shape({
          title: PropTypes.string,
        }),
      }),
      show: PropTypes.shape({
        title: PropTypes.string,
      }),
      title: PropTypes.string,
    }),
    seconds_watched: PropTypes.number,
    slug: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  hasFocus: PropTypes.bool,
  view: PropTypes.string,
}

export default focusable(GridItem)
